/**
 * AgentRunningLogSection
 *
 * Agent 运行日志区域，复用 `<InquiryLog>` 组件（位于 inquiries feature）。
 *
 * - variant="detail" 与原 contact-progress 保持一致
 * - polling 仅在 status=0（运行中）时开启
 * - order="asc" 时间正序（与原页面 1:1）
 *
 * @deprecated Figma Rebuild（spec 001-agent-progress-figma-rebuild T021）后已废弃。
 *   新设计稿不再展示 Agent 运行日志区域；其语义已被 `<ClarificationBoard>` +
 *   `<SuppliersTable>`（每行 lastInteractionAt / replyStatus）替代。
 *   全局零引用 — 已可在下个 housekeeping PR 中物理删除。
 */

import { FC } from 'react';
import { InquiryLog } from '@/features/inquiries/components/inquiry-log';
import type { AgentRunningLogSectionProps } from '../../types';

export const AgentRunningLogSection: FC<AgentRunningLogSectionProps> = ({ inquiryId }) => {
  return <InquiryLog inquiryId={inquiryId} variant="detail" polling={true} order="asc" />;
};

export default AgentRunningLogSection;
